/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBar from './TitleBar';
import PersonalDataView from './PersonalData';
import AccesData from './AccessData';
import Directions from './Directions';
import Subcriptions from './Subcriptions';
import SignOut from './SignOut';
import DatosForm from './forms/datosForm';
import {
  AccessData,
  DirectionData,
  FamiliarData,
  PersonalData,
  PrefijoPais,
  TiposDocumento,
  TiposVia,
} from '../../types/PersonalData';
import DirectionForm from './forms/direccionForm';
import AccesoForm from './forms/accesoForm';
import BajaForm from './forms/bajaForm';
import OpinionForm from './forms/encuestaForm';
import GraciasForm from './forms/graciasForm';
import TarjetaForm from './forms/adicionarTarjetaForm';
import ModalConfirmacion from '../../components/ModalConfirmacion';
import { AuthContextType } from '../../types/Types';
import PreferenciaModVales from './PreferenciaModVales';
import FacturacionForm from './forms/facturacionForm';
import { useMisDatosStore } from './context/MisDatos.context';
import ContactEmailForm from './forms/contactEmailForm';
import Telefono1Form from './forms/telefono1Form';
import ServicioV2PForm from './forms/servicioV2PForm';
import { StorageHelper } from '../../utils/StorageHelper';
import ContactDataView from './ContactDataView';
import DataService from '../../services/MisDatosService';
import useAPIError from '../../hooks/useAPIError';

interface Props {
  showChangePass?: boolean;
  showChangeMail?: boolean;
  showBaja?: boolean;
  showFamily: boolean;
  dataUser: AuthContextType;
  handlerModal: any;
  personalData: PersonalData;
  getPersonalData: any;
  getFamiliarData: any;
  familiarData: FamiliarData;
  setUserForm: any;
  setPassForm: any;
  accessData: AccessData;
  load: boolean;
  promiseApi: boolean;
  getData: any;
  prefijosPaises: PrefijoPais[];
  setVisiblePersonalData: any;
  directionData: DirectionData[];
  setDirectionData: any;
  tipo: string;
  setTipo: any;
  retrieveDirections: any;
  setOnLoadDirectionModal: any;
  isDigital: boolean;
  setIsDigital: any;
  isSocioEroski: boolean;
  setIsSocioEroski: any;
  setShowBajaForm: any;
  showBajaProcessModal: boolean;
  setShowBajaProcessModal: any;
  visiblePersonalData: boolean;
  setPersonalData: any;
  setFamiliarData: any;
  tiposDocumento: TiposDocumento[];
  tiposVia: TiposVia[];
  prefijosPaisesMixtos: PrefijoPais[];
  onLoadDirectionModal: any;
  directionDataNew: DirectionData;
  userForm: boolean;
  passForm: boolean;
  showBajaForm: boolean;
  setShowOpinionForm: any;
  showOpinionForm: boolean;
  setShowGraciasForm: any;
  showGraciasForm: boolean;
  showAccessData: boolean;
  cuentaBloqueada: boolean;
}
const MisDatosCaprabo: FC<Props> = (props) => {
  const {
    showFamily,
    dataUser,
    handlerModal,
    personalData,
    getPersonalData,
    getFamiliarData,
    familiarData,
    setUserForm,
    setPassForm,
    accessData,
    load,
    promiseApi,
    getData,
    prefijosPaises,
    setVisiblePersonalData,
    directionData,
    setDirectionData,
    tipo,
    setTipo,
    retrieveDirections,
    setOnLoadDirectionModal,
    isDigital,
    setIsDigital,
    isSocioEroski,
    setIsSocioEroski,
    setShowBajaForm,
    showBajaProcessModal,
    setShowBajaProcessModal,
    visiblePersonalData,
    setPersonalData,
    setFamiliarData,
    tiposDocumento,
    tiposVia,
    prefijosPaisesMixtos,
    onLoadDirectionModal,
    directionDataNew,
    userForm,
    passForm,
    showBajaForm,
    setShowOpinionForm,
    showOpinionForm,
    setShowGraciasForm,
    showGraciasForm,
    showAccessData,
    cuentaBloqueada,
  } = props;
  const { t } = useTranslation();
  const { addError } = useAPIError();
  const { titular, adicional } = dataUser.user;
  const origen = 'mis-datos';
  const {
    showModalContactEmailForm,
    getModalTelefono1Form,
    showModalTelefono1Form,
    getModalContactEmailForm,
    showModalServicioV2PForm,
    showModalContactEmail,
    goToMisDatosAndOpenModal,
  } = useMisDatosStore();

  useEffect(() => {
    getModalTelefono1Form();
    if (showModalTelefono1Form) {
      StorageHelper.removeshowModalTelefono1();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalTelefono1Form]);

  useEffect(() => {
    getModalContactEmailForm();
    if (showModalContactEmailForm) {
      StorageHelper.removeshowModalContactEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalContactEmailForm]);

  useEffect(() => {
    const source = StorageHelper.getCambioEmailComInv();
    if (source) {
      showModalContactEmail();
    }
    const errorCode = StorageHelper.getModalToUpMisDatos();
    if (errorCode) {
      const errorCodeVerificado = errorCode.trim();
      if (/^-?\d+(\.\d+)?$/.test(errorCodeVerificado)) {
        goToMisDatosAndOpenModal(Number(errorCodeVerificado));
        StorageHelper.removeModalToUpMisDatos();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateFamiliarData = (familiarDataUpdate: FamiliarData) => {
    DataService.updateFamiliarData(familiarDataUpdate).then(
      (responseBajaServicio) => {
        if (responseBajaServicio.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
        getFamiliarData();
      },
    );
  };

  return (
    <>
      {(() => {
        return (
          <>
            <TitleBar />

            <section className="o-section--large section-misdatos">
              <div className="container">
                <PersonalDataView
                  loadModal={handlerModal}
                  personalData={personalData}
                  isFamilyData={showFamily}
                  getData={getPersonalData}
                  familiarData={familiarData}
                  promiseApi={promiseApi}
                />
                <ContactDataView
                  loadModal={handlerModal}
                  personalData={personalData}
                  isFamilyData={showFamily}
                  getData={getPersonalData}
                  familiarData={familiarData}
                  promiseApi={promiseApi}
                />
                <AccesData
                  setUserForm={setUserForm}
                  setPassForm={setPassForm}
                  emailAcceso={accessData.emailAcceso}
                  dobleVerificacion={accessData.dobleVerificacion}
                  showAccessData={showAccessData}
                  load={load}
                  promiseApi={promiseApi}
                  cargarPersonalData={getPersonalData}
                  cargarData={getData}
                  prefijosPaises={prefijosPaises}
                  setShowPersonalData={setVisiblePersonalData}
                  origenData={origen}
                  showV2P
                />

                <Directions
                  directionData={directionData}
                  setDirectionData={setDirectionData}
                  tipo={tipo}
                  setTipo={setTipo}
                  cargarDirecciones={retrieveDirections}
                  setOnLoad={setOnLoadDirectionModal}
                  cuentaBloqueada={cuentaBloqueada}
                />

                <Subcriptions tipo={showFamily} />

                {titular || adicional ? <PreferenciaModVales /> : ''}

                <SignOut
                  isDigital={isDigital}
                  setIsDigital={setIsDigital}
                  isEroski={isSocioEroski}
                  setIsEroski={setIsSocioEroski}
                  setVisible={setShowBajaForm}
                  tipoSocio={personalData.tipoSocioConsumidor}
                  showModal={showBajaProcessModal}
                  setShowModal={setShowBajaProcessModal}
                />

                {/* <AdicionarTarjeta /> */}
              </div>
            </section>
            {showModalContactEmailForm && (
              <ContactEmailForm
                personalData={personalData}
                dobleVerificacion={accessData.dobleVerificacion}
              />
            )}
            {showModalTelefono1Form && (
              <Telefono1Form
                personalData={personalData}
                cargarData={getPersonalData}
              />
            )}
            {showModalServicioV2PForm && (
              <ServicioV2PForm
                personalData={personalData}
                cargarData={getData}
              />
            )}

            <DatosForm
              visible={visiblePersonalData}
              setShow={setVisiblePersonalData}
              personalData={personalData}
              familiarData={familiarData}
              isFamilyData={showFamily}
              setPersonalData={setPersonalData}
              cargarPersonalData={getPersonalData}
              updateFamiliarData={updateFamiliarData}
              setFamiliarData={setFamiliarData}
              cargarAccessData={getData}
              prefijosPaises={prefijosPaises}
              tiposDocumento={tiposDocumento}
            />

            {directionData &&
              directionData.map((d) =>
                d.tipoDireccion !== -1 && d.tipoDireccion === 2 ? (
                  <FacturacionForm
                    key={d.idDireccion}
                    directionData={d}
                    isAdd={false}
                    cargarDirecciones={retrieveDirections}
                    tiposVia={tiposVia}
                  />
                ) : (
                  <DirectionForm
                    directionData={d}
                    isAdd={false}
                    cargarDirecciones={retrieveDirections}
                    prefijosPaises={prefijosPaisesMixtos}
                    onLoad={onLoadDirectionModal}
                    setOnLoad={setOnLoadDirectionModal}
                  />
                ),
              )}
            <DirectionForm
              directionData={directionDataNew}
              isAdd
              cargarDirecciones={retrieveDirections}
              prefijosPaises={prefijosPaisesMixtos}
              onLoad={onLoadDirectionModal}
              setOnLoad={setOnLoadDirectionModal}
            />
            <FacturacionForm
              directionData={directionDataNew}
              isAdd
              cargarDirecciones={retrieveDirections}
              tiposVia={tiposVia}
            />

            <AccesoForm
              userForm={userForm}
              setUserForm={setUserForm}
              passForm={passForm}
              setPassForm={setPassForm}
              accessEmail={accessData.emailAcceso}
              cargarData={getData}
              personalData={personalData}
            />

            <BajaForm
              visible={showBajaForm}
              setVisible={setShowBajaForm}
              setShowOpinionForm={setShowOpinionForm}
              isDigital={isDigital}
              isSocioEroski={isSocioEroski}
              tipoSocio={personalData.tipoSocioConsumidor}
            />

            <OpinionForm
              visible={showOpinionForm}
              setVisible={setShowOpinionForm}
              isDigital={isDigital}
              isEroski={isSocioEroski}
              setShowGraciasForm={setShowGraciasForm}
              setShowBajaForm={setShowBajaForm}
            />

            <GraciasForm visible={showGraciasForm} isDigital={isDigital} />

            <TarjetaForm />

            {personalData.tipoSocioConsumidor === 3 && (
              <ModalConfirmacion
                isBig
                isSmall={false}
                textCentered={false}
                showModal={showBajaProcessModal}
                setShowModal={setShowBajaProcessModal}
                title="Baja para socio consumidor"
                textHTMLContent="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                doAceptar={() => null}
                doClose={() => null}
                showCancel
                acceptButtonTextKey={t('global.confirm')}
              />
            )}
          </>
        );
      })()}
    </>
  );
};

export default MisDatosCaprabo;
